import c from 'classnames';

import {
  oulineNone,
  scrollComponentStyles,
  tabScrollButtonStyles,
  tabsRootStyles,
  tabStyles,
} from './styles';

export const TABS_PROPS = {
  TabScrollButtonProps: {
    classes: {
      disabled: 'hidden',
      root: tabScrollButtonStyles,
    },
    className: scrollComponentStyles,
  },
  classes: {
    flexContainer: 'items-center',
    indicator: 'bg-focus',
    root: c('w-full', tabsRootStyles),
  },
  contentEditable: false,
};

export const TAB_CLASSES = {
  root: c('p-8 min-w-0 w-160', tabStyles),
};

export const TAB_CLASSES_VIEWER = {
  root: c('w-128', oulineNone),
};
